import { FormController } from "./form";
import { loadLead } from "./services/storage";
import type { CapturedLead, InitOptions } from "./types";

export const version = "0.1.0";

let activeController: FormController | null = null;

export function init(options: InitOptions): void {
  destroy();
  activeController = new FormController(options);
  activeController.init().catch((err) => {
    try {
      options.onError?.(
        Object.assign(err instanceof Error ? err : new Error(String(err)), {
          phase: "validation" as const,
        })
      );
    } catch (handlerErr) {
      console.error("onError handler threw:", handlerErr);
    }
  });
}

export function destroy(): void {
  if (activeController) {
    activeController.destroy();
    activeController = null;
  }
}

export function getCapturedLead(): CapturedLead | null {
  return loadLead();
}

const RedactoDpdpaReport = { init, destroy, getCapturedLead, version };
export default RedactoDpdpaReport;

export type {
  InitOptions,
  BrandingConfig,
  CapturedLead,
  FormError,
} from "./types";
